import { api } from "./apiService";

const checkStatus = (json) => {
    if (json && typeof json.StatusCode === 'number' && json.StatusCode !== 200) {
        throw new Error(json.Result || 'Request failed');
    }
    return json;
};

/**
 * Fetch all tax rules for a given year.
 * GET /TaxFile/GetTaxFIleByYear?p_year=YYYY
 */
const GetTaxFileByYear = async (year) => {
    const params = new URLSearchParams({
        p_year: String(year),
    });
    const json = await api.get(`/TaxFile/GetTaxFIleByYear?${params.toString()}`);
    return checkStatus(json);
};

/**
 * Add a new tax rule.
 * POST /TaxFile/AddTaxFile?p_year=...&p_minAmount=...&...
 * (params go in the query string, body is empty)
 */
const AddTaxFile = async ({
    year,
    minAmount,
    maxAmount,
    taxPercentage,
    deducAmount,
    incomeRange,
    tableNo,      // optional – omit to start a new table for the year
}) => {
    const safeNum = (v, fallback = 0) => {
        if (v === null || v === undefined || v === '') return String(fallback);
        const n = Number(v);
        return String(Number.isFinite(n) ? n : fallback);
    };

    const params = new URLSearchParams({
        p_year:          safeNum(year),
        p_minAmount:     safeNum(minAmount),
        p_maxAmount:     safeNum(maxAmount),
        p_taxPercentage: safeNum(taxPercentage),
        p_deducAmount:   safeNum(deducAmount),
        p_incomeRange:   incomeRange ?? '',
    });

    // Only include p_tableNo when adding to an existing active table.
    // Omitted entirely when starting a new table.
    if (tableNo !== undefined && tableNo !== null && tableNo !== '') {
        params.append('p_tableNo', safeNum(tableNo));
    }

    // POST with query-string params, no request body
    const json = await api.post(`/TaxFile/AddTaxFile?${params.toString()}`);
    return checkStatus(json);
};

const ApproveTaxFile = async (year, tableNo) => {
    const params = new URLSearchParams({
        p_year: String(year),
        p_tableNo: String(tableNo),
    })
    const json = await api.post(`/TaxFile/ApproveTaxFile?${params.toString()}`);
    return checkStatus(json);
}

const taxTableService = {
    GetTaxFileByYear,
    AddTaxFile,
    ApproveTaxFile,
};

export default taxTableService;